/**
 * The page the server-error view's Refresh button returns to. The value comes
 * from the `redirect` query, so only a path on this origin is accepted: it must
 * start with `/` and resolve to this origin. Resolving it the way the browser
 * will, rather than matching prefixes, also rejects values such as `/\t/host`,
 * whose tab the URL parser strips to leave `//host`.
 */
export function resolveServerErrorRedirect(value: unknown): string | null {
    if (typeof value !== 'string' || !value.startsWith('/')) {
        return null;
    }

    let url: URL;
    try {
        url = new URL(value, window.location.origin);
    } catch {
        return null;
    }

    if (url.origin !== window.location.origin) {
        return null;
    }

    return url.pathname + url.search + url.hash;
}

/** The current page, as the `redirect` value to carry to the server-error view. */
export function currentPageRedirect(): string {
    return window.location.pathname + window.location.search + window.location.hash;
}
